import React from "react";
import { theme } from "../../theme/theme";
import { LocaleContext } from "../../contexts/LocaleContext";
import snippets from "../../locales/snippets.yml";
import { useHubspotForm } from "./useHubspotForm";
import { useStaticQuery, graphql } from "gatsby";

const GdprConsent = ({ locale }) => {
  const data = useStaticQuery(graphql`
    query qdpr {
      datoCmsGlobal {
        _allGdprConsentLocales {
          value
          locale
        }
      }
    }
  `);
  return (
    <div
      css={`
        color: ${theme.primary};
        font-size: 14px;
        margin-top: 16px;
        a {
          font-weight: 700;
          transition: all 0.2s;
          &:hover {
            color: ${theme.accent};
          }
        }
      `}
      dangerouslySetInnerHTML={{
        __html: data.datoCmsGlobal._allGdprConsentLocales.find(
          (v) => v.locale === locale
        )?.value
      }}
    />
  );
};

export const HubSpotFormNewsletter = () => {
  const { locale } = React.useContext(LocaleContext);
  const snippet = snippets[locale];

  const { submitted, hsForm } = useHubspotForm(
    locale === "fi"
      ? "e75502d6-10fb-4546-8d3c-e92f16b06fdd"
      : "faabb1c3-6ee4-4226-ad85-fee05a21282e"
  );

  return (
    <div>
      {!submitted ? (
        <>
          {hsForm}
          <GdprConsent locale={locale} />
        </>
      ) : (
        <p>{snippet.form.pdfSuccess}</p>
      )}
    </div>
  );
};
